module.exports = __webpack_public_path__ + "img/fogg-no-messages-2.6983da94.png";